import { Component, Input, OnInit } from '@angular/core';
import { NgxHmCarouselBreakPointUp } from 'ngx-hm-carousel';
import { HttpParams } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  @Input() mediaContent;
  @Input() showArrowsIfOneElement ? = true;

  currentIndex = 0;
  speed = 5000;
  infinite = 'infinite';
  direction = 'right';
  directionToggle = true;
  autoplay = true;
  breakpoints: NgxHmCarouselBreakPointUp[] = [
    {width: 767, number: 1},
    {width: 1139, number: 2},
    {width: 1140767, number: 3},
  ];

  mediaContentUrls = [
    'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRbnZaANt06ZaavXnSVdh-hGnIj7AJc3Z_87Rpk1EmSJrwhVWIg&usqp=CAU',
    'https://guidetoiceland.imgix.net/4898/x/0/?auto=format%2Ccompress&fit=crop&crop=faces%2Cedges%2Ccenter&ixlib=react-8.6.4&h=430&w=1400',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQTBzdRt6fiiW7znmZYOZs0TOw2Vv5_0HWxtplfVm08DjxiDtgf&usqp=CAU',
    'https://media3.s-nbcnews.com/j/newscms/2019_37/3008306/ss-190912-twip-05_a78cf5b1c44cee7e52b935b8983bc000.focal-360x700.jpg',
    'https://mydiscoveries.ru/wp-content/uploads/2016/12/ec5302faff864a4bddc9cf915ad6c3b1.jpg',
    'https://miro.medium.com/max/5120/1*nQh9lM6488mZ3ldWPUCMLQ.png',
    'http://temp-cdn.datalock.ru/fi2lm/f4f3cc2d4653d3b9957737e573efea17/7f_The.Flash.S06E01.720p.rus.LostFilm.TV.a1.11.10.19.mp4',
    'http://data05-cdn.datalock.ru/fi2lm/f4f3cc2d4653d3b9957737e573efea17/7f_The.Flash.S06E02.720p.rus.LostFilm.TV.a1.17.10.19.mp4'
  ];

  constructor(private sanitizer: DomSanitizer,
              private languageService: LanguageService) { }

  ngOnInit(): void {
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }

  isImage(url: string): boolean {
    const formats = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];
    return formats.some(item => url.includes(item));
  }

  isVideo(url: string): boolean {
    const formats = ['.mp4'];
    return formats.some(item => url.includes(item));
  }

  isYoutubeVideo(url: string): boolean {
    return url.includes('www.youtube.com');
  }

  getSrcDocLayout(url: string) {
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      const embeddedLink = 'https://www.youtube.com/embed/' + httpParams.get('v').toString() + '?autoplay=1';
      const embeddedImgPreview = 'https://img.youtube.com/vi/' + httpParams.get('v').toString() + '/hqdefault.jpg';

      return this.sanitizer.bypassSecurityTrustHtml(
        `
        <style>
            *{padding:0;margin:0;overflow:hidden}
            html,body{height:100%}
            .preview{position:absolute;width:100%;top:0;bottom:0;margin:auto}
            .load-video {
                position: absolute;
                top: calc(50% - 51.5px);
                left: calc(50% - 51.5px);
                width: 103px;
                height: 103px;
                filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
            }
        </style>
        <a href=${embeddedLink}><img loading="lazy" class="preview" src=${embeddedImgPreview} alt=''>
            <img loading="lazy" class="load-video" src="/assets/icons/play.svg" alt="play">
        </a>`);
    }
  }

  playVideo(element: HTMLVideoElement): void {
    element.play();
  }

  pauseVideo(element: HTMLVideoElement): void {
    element.pause();
  }

  isPaused(element: HTMLVideoElement): boolean {
    return element.paused;
  }

  previousSlide(): void {
    this.currentIndex = this.currentIndex === 0 ? this.mediaContent.length - 1 : --this.currentIndex;
  }

  nextSlide(): void {
    this.currentIndex = this.currentIndex === this.mediaContent.length - 1 ? 0 : ++this.currentIndex;
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }
}
